module.exports = __webpack_public_path__ + "static/img/image3_jc.8d78dcd0.jpg";